export default "__VITE_ASSET__2b3c11a3__"